import { viewerApi } from '@viewer/lib/viewerApi'

// Pintura do relatório IDS no 3D, na camada de cores do diff.
//
// Porque é que isto precisa de registo: desde que o relatório passou a
// viver no store (ver `store/idsModuleSlice.ts`), o painel flutuante e a
// página do módulo mostram o MESMO relatório e podem estar montados ao
// mesmo tempo - o painel vive no canvas, que nunca desmonta. Com o
// antigo "despinto sempre que desmonto", sair da página apagava a
// pintura que o painel ainda estava a mostrar. Agora cada surface
// regista-se como pintor e só se despinta quando sai o último.

type IdsColorMap = Parameters<typeof viewerApi.applyDiffColors>[0]

const painters = new Set<object>()

/** Pinta e regista `token` como pintor activo. */
export async function idsPaintOn(
  token: object,
  colors: IdsColorMap,
): Promise<void> {
  painters.add(token)
  await viewerApi.applyDiffColors(colors)
}

/** Larga `token`; só despinta se não sobrar mais ninguém a pintar. */
export async function idsPaintOff(token: object): Promise<void> {
  painters.delete(token)
  if (painters.size === 0) await viewerApi.clearDiffColors()
}
